import type { RouteObject } from 'react-router';

import { dashboardRoutes as incheonRoutes } from './incheon';
import { dashboardRoutes as michuholRoutes } from './michuhol';

export const dashboardRoutes: RouteObject[] =
  import.meta.env.VITE_STATE_NAME === 'mch' ? michuholRoutes : incheonRoutes;
